import type { ReactNode } from 'react';

import type { TNavbarDropdownElement } from '@shared/dream-components';
import { NavbarMenuDropdownV2 as NavbarMenuDropdownElement } from '@shared/dream-components';

interface Props {
  node: TNavbarDropdownElement;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const NavbarMenuDropdown = ({ node, children, screen }: Props) => {
  return (
    <NavbarMenuDropdownElement element={node} controlbyselected="false" screen={screen}>
      {children}
    </NavbarMenuDropdownElement>
  );
};

export default NavbarMenuDropdown;
